/**
 * InputHandler - Handles user input processing and validation
 */
export class InputHandler {
  constructor(
    commandProcessor,
    stepProcessor,
    redirectHandler,
    sessionManager
  ) {
    this.commandProcessor = commandProcessor;
    this.stepProcessor = stepProcessor;
    this.redirectHandler = redirectHandler;
    this.sessionManager = sessionManager;
  }

  /**
   * Process user input for current step
   */
  async processInput(input, currentStep, sessionData, callbacks = {}) {
    // Validate input
    const validationResult = await this.commandProcessor.validateInput(
      currentStep,
      input,
      sessionData,
      null, // loadedData
      callbacks
    );

    if (validationResult !== true) {
      return { validationError: validationResult };
    }

    // Store input using session manager
    if (currentStep.field) {
      this.sessionManager.updateSessionData(currentStep.field, input);
    }

    if (currentStep.onStep) {
      const { executeStepFunction } = await import(
        "../../utils/command/stepDataLoader"
      );
      const dynamicData = await executeStepFunction(
        currentStep.onStep,
        input,
        sessionData,
        null,
        callbacks
      );
      Object.assign(sessionData, dynamicData);
    }

    // Persist modified sessionData back to SessionManager
    this.sessionManager.mergeSessionData(sessionData);

    // Process step outro
    const stepOutro = await this.commandProcessor.processStepOutro(
      currentStep,
      input,
      sessionData,
      null,
      callbacks
    );

    return { stepOutput: stepOutro, sessionData };
  }

  /**
   * Handle validation error by rebuilding prompt
   */
  async handleValidationError(error, currentStep, sessionData, promptResolver) {
    const prompt = await promptResolver.resolvePrompt(currentStep, {
      skipIntro: true,
      sessionData,
    });
    return { output: error, prompt };
  }
}
